export const boldText = () => ({ dataText: { fontWeight: 'bold' } });
export const normalText = () => ({ dataText: { fontWeight: 'normal' } });
export const leftWideCell = () => ({ item: { paddingLeft: '32px' } });
